import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import PermissionGuard from "../../components/auth/PermissionGuard";

export default function UsersPage() {
  const [rows, setRows] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    password: "",
    status: "active",
    must_change_password: true,
    role_ids: [],
  });

  async function loadData() {
    setLoading(true);
    try {
      const [usersRes, rolesRes] = await Promise.all([
        axios.get("/admin/users"),
        axios.get("/admin/roles"),
      ]);

      setRows(usersRes.data?.data || usersRes.data?.data?.data || usersRes.data?.data || []);
      setRoles(rolesRes.data?.data || []);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  async function handleCreate(e) {
    e.preventDefault();
    await axios.post("/admin/users", form);
    setForm({
      first_name: "",
      last_name: "",
      email: "",
      username: "",
      password: "",
      status: "active",
      must_change_password: true,
      role_ids: [],
    });
    await loadData();
  }

  return (
    <PermissionGuard permission="security.users.view">
      <div>
        <h2>Users</h2>

        <form
          onSubmit={handleCreate}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: 12,
            marginBottom: 24,
            background: "#fff",
            padding: 16,
            borderRadius: 12,
          }}
        >
          <input
            placeholder="First Name"
            value={form.first_name}
            onChange={(e) => setForm((prev) => ({ ...prev, first_name: e.target.value }))}
          />
          <input
            placeholder="Last Name"
            value={form.last_name}
            onChange={(e) => setForm((prev) => ({ ...prev, last_name: e.target.value }))}
          />
          <input
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
          />
          <input
            placeholder="Username"
            value={form.username}
            onChange={(e) => setForm((prev) => ({ ...prev, username: e.target.value }))}
          />
          <input
            placeholder="Password"
            type="password"
            value={form.password}
            onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
          />

          <select
            value={form.status}
            onChange={(e) => setForm((prev) => ({ ...prev, status: e.target.value }))}
          >
            <option value="active">active</option>
            <option value="inactive">inactive</option>
            <option value="suspended">suspended</option>
            <option value="locked">locked</option>
          </select>

          <select
            multiple
            value={form.role_ids}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                role_ids: Array.from(e.target.selectedOptions, (opt) => Number(opt.value)),
              }))
            }
            style={{ gridColumn: "span 2", minHeight: 100 }}
          >
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </select>

          <button type="submit">Create User</button>
        </form>

        <div style={{ background: "#fff", padding: 16, borderRadius: 12 }}>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <table width="100%" cellPadding="10">
              <thead>
                <tr>
                  <th align="left">Name</th>
                  <th align="left">Email</th>
                  <th align="left">Username</th>
                  <th align="left">Status</th>
                  <th align="left">Roles</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name || `${user.first_name || ""} ${user.last_name || ""}`}</td>
                    <td>{user.email}</td>
                    <td>{user.username}</td>
                    <td>{user.status}</td>
                    <td>{(user.roles || []).map((r) => r.name).join(", ")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </PermissionGuard>
  );
}
